import * as React from "react";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import cargandoCard from "../../components/cargando-card";
import { obtenerListaMascotaPorRefugio } from "../../api/api-mascota";
import MascotaCardComponent from "../../components/mascota-card-componenet";
import { sharedNextPage } from "../../utils/shared-functions";


export default function DashboardScreen() {

    const history = useHistory();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
    const [listaMascotas, setListaMascotas] = useState([]);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const lista = await obtenerListaMascotaPorRefugio();
            // console.log('lista', lista);
            if (lista.error === false) {
                setListaMascotas(lista.body);
            }
            setCargandoPage(false);
            setTieneAccesoAlModulo(true);
        } catch (err) {
            setTieneAccesoAlModulo(false);
            console.log('iniciar err');
            console.log(err);
        }
    };

    const navigateToMascota = () => {
        let obj = {};
        let data = {};
        data.id = 0;
        data.nombre = "";
        data.raza = "";
        data.color = "";
        data.edad = "";
        data.idDepartamento = null;
        obj.titulo = "REGISTRAR MASCOTA";
        obj.params = data;
        sharedNextPage("administracion/gestionar-mascota/mascota", obj, history);
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            // if (tieneAccesoAlModulo === false) {
            //     return sinAccesoCard();
            // }
            return (
                <div className="m-4">
                    <div className='flex flex-row justify-between'>
                        <div>
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="departamento">
                                MIS MASCOTAS
                            </label>

                        </div>
                        <div>
                            <button className="px-6 py-2 text-white bg-blue-600 hover:bg-blue-700 font-semibold rounded-lg shadow-md transition duration-300"
                                onClick={() => { navigateToMascota(); }}
                            >
                                NUEVO
                            </button>
                        </div>
                    </div>
                    <br />
                    <hr />
                    <br />
                    <div className="flex flex-wrap">
                        {listaMascotas.map((mascota, index) => (
                            <MascotaCardComponent key={index} mascota={mascota} />
                        ))}
                    </div>
                </div>
            );
        } catch (err) {
            console.log('render err dashboard');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }


    return render();
};
